window.addEventListener("load", () => {
    const regularPriceElement = document.querySelector(".productView .productView-price .price__regular .price-item");
    const regularPrice = regularPriceElement.textContent.trim().slice(0, -4);
    const boldOptions = document.querySelector(".bold_options");
    const boldOptionsObserver = new MutationObserver(() => {
        const boldTotal = boldOptions.querySelector(".bold_option_total > div:first-child");
        if (boldTotal) {
            boldOptionsObserver.disconnect();

            updateTotal(boldTotal, regularPrice);
            const boldTotalObserver = new MutationObserver(() => {
                boldTotalObserver.disconnect();
                updateTotal(boldTotal, regularPrice);
                boldTotalObserver.observe(boldTotal, { childList: true, subtree: true });
            });
            boldTotalObserver.observe(boldTotal, { childList: true, subtree: true });
        }
    });
    boldOptionsObserver.observe(boldOptions, { childList: true, subtree: true });
});

function updateTotal(element, regularPrice) {
    const chargePriceElement = element.querySelector("span");
    if (chargePriceElement) {
        element.textContent = `Total: ${regularPrice} + ${chargePriceElement.textContent}`;
    }
}